<template>
  <NotificationBase>
    <template v-slot:icon>
      <img
        class="h-full object-center object-contain w-full"
        src="@/assets/icons/note-danger.svg">
    </template>
    <template v-slot>
      <span class="text-12px leading-14px">
        Заказчик отменил заказ
        <b
          class="cursor-pointer"
          @click="onClick">{{ id }}</b>.
        Причина отказа: {{ cancellationReason }}.
        <span v-if="cancellationComment && cancellationComment.length">
        Комментарий: {{ cancellationComment }}</span>
        Средства возвращены на счет заказчика:
        {{ $numeral(parseFloat(refundAmount)).format('0,0 $') }}
      </span>
    </template>
  </NotificationBase>
</template>

<script>
import NotificationBase from '@/components/Notifications/Core/NotificationBase.vue';
import cancellationReasonsJson from '@/components/Notifications/cancellation-reasons.json';

export default {
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  components: {
    NotificationBase,
  },
  computed: {
    id() {
      return this.$delve(this.payload, 'orderCancelledByCustomer.order.id');
    },
    cancellationReason() {
      const key = this.$delve(this.payload, 'orderCancelledByCustomer.order.cancellationReason');
      return cancellationReasonsJson[key] || key;
    },
    cancellationComment() {
      const comment = this.$delve(this.payload, 'orderCancelledByCustomer.order.cancellationComment');
      return comment;
    },
    refundAmount() {
      return this.$delve(this.payload, 'orderCancelledByCustomer.refundAmount');
    },
  },
  methods: {
    onClick() {
      this.$router.push({
        name: 'orders.info',
        params: {
          id: this.id,
        },
      });
      this.$bvModal.hide('notifications');
    },
  },
};
</script>
